"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTransactionType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var BulkInsurancePayment_1 = require("./BulkInsurancePayment");
var Transaction_1 = require("./Transaction");
var TransactionType_1 = require("./TransactionType");
var PaymentTransactionType_Factory = /** @class */ (function () {
    function PaymentTransactionType_Factory() {
    }
    PaymentTransactionType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            BulkInsurancePayments: model.BulkInsurancePayments && model.BulkInsurancePayments.map(function (i) { return BulkInsurancePayment_1.BulkInsurancePayment_Factory.CreateIncoming(i); }),
            Description: model.Description,
            IsSystemDefined: model.IsSystemDefined,
            NotUserEditable: model.NotUserEditable,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            ShowDepositSlip: model.ShowDepositSlip,
            Transactions: model.Transactions && model.Transactions.map(function (i) { return Transaction_1.Transaction_Factory.CreateIncoming(i); }),
            TransactionType: TransactionType_1.TransactionType_Factory.CreateIncoming(model.TransactionType),
            TransactionTypeCode: model.TransactionTypeCode,
        };
        return result;
    };
    PaymentTransactionType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            BulkInsurancePayments: model.BulkInsurancePayments && model.BulkInsurancePayments.map(function (i) { return BulkInsurancePayment_1.BulkInsurancePayment_Factory.CreateOutgoing(i); }),
            Description: model.Description,
            IsSystemDefined: model.IsSystemDefined,
            NotUserEditable: model.NotUserEditable,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            ShowDepositSlip: model.ShowDepositSlip,
            Transactions: model.Transactions && model.Transactions.map(function (i) { return Transaction_1.Transaction_Factory.CreateOutgoing(i); }),
            TransactionType: TransactionType_1.TransactionType_Factory.CreateOutgoing(model.TransactionType),
            TransactionTypeCode: model.TransactionTypeCode,
        };
        return result;
    };
    return PaymentTransactionType_Factory;
}());
exports.PaymentTransactionType_Factory = PaymentTransactionType_Factory;
